export enum StaticOrientation {
  Portrait = 'Portrait',
  Landscape = 'Landscape'
}
